export const PORTFOLIO_SITUATIONS = [
  "ALUGADO",
  "ALUGANDO",
  "EM_RESCISAO",
  "EM_MANUTENCAO",
] as const;

export const PORTFOLIO_SORTS = [
  "condominium",
  "rent_amount",
  "days_vacant",
  "contract_end",
] as const;

export const PORTFOLIO_METRICS_DAYS = [30, 60, 90] as const;

export const PORTFOLIO_DIAGNOSES = [
  "BAIXA_EXPOSICAO",
  "PRECO_CARACTERISTICAS",
  "CONSERVACAO",
] as const;

export const INSPECTION_STATUSES = [
  "idle",
  "queued",
  "searching",
  "ready",
  "not_found",
  "ambiguous",
  "unavailable",
] as const;

export type PortfolioSituation = (typeof PORTFOLIO_SITUATIONS)[number];
export type PortfolioSort = (typeof PORTFOLIO_SORTS)[number];
export type PortfolioMetricsDays = (typeof PORTFOLIO_METRICS_DAYS)[number];
export type PortfolioDiagnosis = (typeof PORTFOLIO_DIAGNOSES)[number];
export type InspectionStatus = (typeof INSPECTION_STATUSES)[number];

export interface PortfolioFunnel {
  period_days: number;
  page_views: number | null;
  schedule_clicks: number | null;
  schedules: number;
  visits: number;
  offers: number;
  shared_listing: boolean;
  analytics_available: boolean;
  notice: string | null;
}

export interface PortfolioProperty {
  kenlo_property_id: string;
  property_id: number | null;
  listing_property_id: number | null;
  contract_code: string | null;
  title: string | null;
  rent_amount: number | null;
  condominium_name: string | null;
  condominium_fee: number | null;
  owner_name: string | null;
  unit: string | null;
  area: number | null;
  area_display: string;
  furnished: string | null;
  situation: PortfolioSituation;
  situation_label: string;
  contract_start: string | null;
  contract_end: string | null;
  address: string | null;
  city: string | null;
  characteristics_available: boolean;
  characteristics_notice: string | null;
  days_vacant: number | null;
  funnel: PortfolioFunnel;
  diagnosis: PortfolioDiagnosis | null;
  diagnosis_label: string | null;
}

export interface PortfolioKpis {
  total: number;
  rented: number;
  vacant: number;
  occupancy_rate: number | null;
  vacant_monthly_rent: number | null;
}

export interface PortfolioAppliedFilters {
  situation: PortfolioSituation | null;
  condominium: string | null;
  sort: PortfolioSort;
  metrics_days: PortfolioMetricsDays;
}

export interface OwnerPortfolioData {
  kpis: PortfolioKpis;
  condominiums: string[];
  properties: PortfolioProperty[];
  property_ids: number[];
  applied_filters: PortfolioAppliedFilters;
  situation_labels: Record<PortfolioSituation, string>;
}

export interface OwnerPortfolioQuery {
  situation: PortfolioSituation | null;
  condominium: string | null;
  sort: PortfolioSort;
  metricsDays: PortfolioMetricsDays;
}

export interface InspectionReport {
  inspected_on: string;
  inspected_on_display: string;
  label: string;
  open_path: string;
}

export interface InspectionCache {
  kenlo_property_id: string;
  status: InspectionStatus;
  message: string | null;
  searched_at: string | null;
  report: InspectionReport | null;
}

export interface InspectionFile {
  url: string;
  expires_in_seconds: number | null;
}
